import React from 'react'
import cx from 'classnames'

import styles from './Tab.module.scss'

type TabProps = {
  children?: React.ReactNode
  className?: string
  id?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  isDisabled?: boolean
}

export const Tab = React.forwardRef<HTMLButtonElement, TabProps>(
  ({ children, className, id, onClick, isDisabled }, ref) => (
    <button
      className={cx(styles.tab, { [styles.disabled]: isDisabled }, className)}
      data-testid="tab"
      id={id}
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
    >
      <span className={styles.content}>{children}</span>
    </button>
  ),
)
